import React from "react";
import { FeatureArticleRichText } from "web/react/components/feature-article/feature-article-rich-text";
import { FeatureArticleFaq } from "web/react/components/feature-article/types";
import { withHardBreaks } from "web/react/components/feature-article/utils";
import { Accordion } from "web/react/emo/accordion";
import { Heading } from "web/react/emo/heading";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";

interface FeatureArticleFaqsProps {
    heading: string;
    faqs: FeatureArticleFaq[];
}

export function FeatureArticleFaqs({ heading, faqs }: FeatureArticleFaqsProps): React.ReactElement {
    return (
        <VStack spacing="lg">
            <Heading as="h2" textStyle={{ sm: "hero-s", lg: "hero" }}>
                {heading}
            </Heading>
            <View>
                <Accordion
                    items={faqs.map((faq, index) => ({
                        title: faq.question,
                        isOpen: index === 0,
                        children: (
                            <FeatureArticleRichText>
                                {withHardBreaks(faq.answer)}
                            </FeatureArticleRichText>
                        ),
                    }))}
                />
            </View>
        </VStack>
    );
}
